import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { handleLogout } from '../../actions/index';
import { Button } from "@blueprintjs/core";

class LogoutButton extends React.Component {

  render() {
    return <Button
      className="pt-minimal"
      icon="log-out"
      onClick={() => this.props.handleLogout()}
    />;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    handleLogout
  }, dispatch)
}

export default connect(null, mapDispatchToProps)(LogoutButton);



// WEBPACK FOOTER //
// ./src/containers/LogoutButton/index.js